export default "__VITE_ASSET__8845e275__"